import { render, staticRenderFns } from "./MasqueradeModal.vue?vue&type=template&id=8be42442&"
import script from "./MasqueradeModal.vue?vue&type=script&lang=ts&"
export * from "./MasqueradeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports